/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Autocomplete, RenderInputParams } from '@material-ui/lab';
import { TextField, CircularProgress, ListItemText } from '@material-ui/core';
// import { showNotification } from '../../App';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            // minWidth: '200px',
        },
    }),
);

interface AffinityBranchSelectorProps {
    disabled?: boolean;
    required?: boolean;
    multiple?: boolean;
    // tslint:disable-next-line: no-any
    value?: IAutoCompleteItem | any; // value only available in single select
    error?: boolean;
    onSelection?: (value: IAutoCompleteItem | IAutoCompleteItem[], name: string) => void;
    className?: string;
    helperText?: string;
    name?: string;
    label?: string;
    disablePortal?: boolean;
    onBlur?: React.FocusEventHandler<HTMLDivElement>;
    filter?: {
        category?: string;
        state?: string;
    };
}

export interface MatterTypeOptionProps extends AffinityBranchOption, IAutoCompleteItem {}

interface AffinityBranchSelectorState {
    isLoading: boolean;
    options: MatterTypeOptionProps[];
}

export const AffinityBranchSelector: React.FC<AffinityBranchSelectorProps> = (props) => {
    const classes = useStyles();

    const [state, setState] = useState<AffinityBranchSelectorState>({
        isLoading: false,
        options: [],
    });

    const affinityBranchQuery = useQuery<MatterTypeData>(AffinityBranchQuery);

    useEffect(() => {
        if (!affinityBranchQuery.loading && !affinityBranchQuery.error && affinityBranchQuery.data && affinityBranchQuery.data.lookup && affinityBranchQuery.data.lookup.affinityBranch) {
            setState((prevState) => {
                const { affinityBranch } = affinityBranchQuery.data!.lookup;

                const filteredMatterType = affinityBranch.map((source: AffinityBranchOption) => ({ ...source, value: source.typeId, label: source.description }));
                return {
                    ...prevState,
                    options: filteredMatterType,
                    isLoading: false,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [affinityBranchQuery.loading, affinityBranchQuery.error, affinityBranchQuery.data, props.filter]);

    // tslint:disable-next-line: no-any
    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        // tslint:disable-next-line: no-console
        console.log('onChange', value);
        if (props.onSelection) {
            props.onSelection(value, props.name ? props.name : 'matterType');
        }
    };

    const getInputProps = (params: RenderInputParams, isLoading?: boolean) => {
        return {
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                    {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                    {params.InputProps.endAdornment}
                </React.Fragment>
            ),
        };
    };

    return (
        <div className={`${classes.root} ${props.className}`}>
            {props.multiple ? (
                <Autocomplete
                    value={props.value}
                    multiple={true}
                    loading={affinityBranchQuery.loading}
                    disabled={props.disabled}
                    onChange={handleChange}
                    options={state.options}
                    disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={(option: IAutoCompleteItem) => option.label}
                    getOptionSelected={(option, value) => value.value === option.value}
                    onBlur={props.onBlur}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label ? props.label : 'Matter Type'}
                            variant="standard"
                            fullWidth={true}
                            margin="none"
                            required={props.required}
                            InputProps={getInputProps(params, affinityBranchQuery.loading)}
                            error={props.error}
                            helperText={props.helperText}
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        // const matches = match(option.label, inputValue);
                        // const parts = parse(option.label, matches);

                        const selected = option.label === inputValue;
                        return (
                            <ListItemText
                                primary={<div style={{ fontWeight: selected ? 600 : 'inherit' }}>{option.label}</div>}
                                // secondary={`State: ${option.state}`}
                            />
                        );
                    }}
                />
            ) : (
                <Autocomplete
                    value={props.value}
                    loading={affinityBranchQuery.loading}
                    disabled={props.disabled}
                    onChange={handleChange}
                    options={state.options}
                    disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={(option: IAutoCompleteItem) => option.label}
                    onBlur={props.onBlur}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label ? props.label : 'Matter Type'}
                            variant="standard"
                            fullWidth={true}
                            margin="none"
                            required={props.required}
                            InputProps={getInputProps(params, affinityBranchQuery.loading)}
                            error={props.error}
                            helperText={props.helperText}
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        // const matches = match(option.label, inputValue);
                        // const parts = parse(option.label, matches);
                        const selected = option.label === inputValue;
                        return (
                            <ListItemText
                                primary={<div style={{ fontWeight: selected ? 600 : 'inherit' }}>{option.label}</div>}
                                // secondary={`State: ${option.state}`}
                            />
                        );
                    }}
                />
            )}
        </div>
    );
};

export interface MatterTypeData {
    lookup: Lookup;
}

export interface Lookup {
    affinityBranch: AffinityBranchOption[];
}

export interface AffinityBranchOption {
    typeId: string;
    description: string;
}

export const AffinityBranchQuery = gql`
    query AffinityBranch {
        lookup {
            affinityBranch {
                typeId
                description
            }
        }
    }
`;
